module.exports = __webpack_public_path__ + "img/sb.fd8aecd6.png";